import { Box, Button, DialogTitle, ThemeProvider } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import React from "react";
import { FormattedMessage } from "react-intl";
import Table, { TableColumn } from "legacy-components/table/Table";
import Badge from "legacy-components/badge/Badge";
import { TeamJoiner } from "./TeamJoiner";
import { Teamcreator } from "./TeamCreator";
import { theme } from "themes/mui";

export interface TeamListViewerProps {
  selectOpen: boolean;
  selectToggle: () => void;
  joinOpen: boolean;
  joinToggle: any
  data: any;
  setSelectedTeamName: any;
  handleChangeNew: any;
  selectedTeamName: any
  refreshUserTeams: any;
  userUuid: string;
  getAvailableTeams: any
  availableTeamsState: any
  toggleSubscriptionDialog?: ()=> void;
  subscriptionDialogOpen?: boolean
  newUser : boolean
  accountsState: any
}

export const TeamListViewer: React.FC<TeamListViewerProps> = ({
  selectOpen,
  selectToggle,
  joinOpen,
  joinToggle,
  data,
  setSelectedTeamName,
  handleChangeNew,
  selectedTeamName,
  refreshUserTeams,
  userUuid,
  getAvailableTeams,
  availableTeamsState,
  toggleSubscriptionDialog,
  subscriptionDialogOpen,
  newUser,
  accountsState,

}) => {
  const StatusBadge = ({ data }: any) => {
    return (
      <Box style={{ justifyContent: "space-between" }}>
        <Badge color="primary" label={data?.role?.iamRole?.toUpperCase()} />
      </Box>
    );
  };

  const redirectTeam = (data: any) => {
    if(selectedTeamName !== data?.data?.team?.teamName) {
      handleChangeNew(data?.data?.team);
      setSelectedTeamName(data?.data?.team?.teamName);
    }
    selectToggle();  
  };
  return (
    <Dialog
      open={selectOpen}
      title="Select a Team"
      onClose={selectToggle}
      fullWidth={true}
      style={{ padding: "24px 21px 24px 21px", minWidth: "1001px" }}
      PaperProps={{
        style: {
          width: '1001px', 
          maxWidth: '1001%', 
          minWidth: '300px' 
        }
      }}
    >
      <ThemeProvider theme={theme}>
        <div>
            <DialogTitle
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box style={{display: "flex", flexDirection: "row", marginTop: "20px"}}>
              <div style={{marginLeft: "10px"}}></div>
              <FormattedMessage defaultMessage="Select a team" ></FormattedMessage>

              
              <div style={{marginLeft: "447px", marginRight: "29px"}}>
                
              <TeamJoiner refreshUserTeams={refreshUserTeams} userUuid={userUuid} getAvailableTeams={getAvailableTeams} state={availableTeamsState} open={joinOpen} toggle={joinToggle} teamList={data} newUser={newUser} accountsState={accountsState}/>

              </div>
              <div style={{marginRight: "10px"}}> 
              <Teamcreator refreshUserTeams={refreshUserTeams} toggleSubscriptionDialog={toggleSubscriptionDialog} subscriptionDialogOpen={subscriptionDialogOpen} newUser={newUser} accountsState={accountsState}/>
              </div>
              </Box>
            </DialogTitle>
           
          <Box style={{ padding: "0px 30px 30px 30px" }}>
            <Table
              noRowsText={`You are not associated with any team`}
              rowData={data}
              height="506px"
              pagination={false}
            >
              <TableColumn
                field="team.teamName"
                flex={2}
                cellRenderer="Title"
                headerName="Name"
                sortable
                unSortIcon={true}
                filter="agTextColumnFilter"
                filterParams={{
                  suppressAndOrCondition: true,
                  defaultOption: "contains",
                  filterOptions: ["contains"],
                }}
                onCellClicked={redirectTeam}
                cellStyle={{
                whiteSpace: "normal",  
                wordBreak: "break-word" 
  }}
              />
              <TableColumn
                field="role.iamRole"
                flex={2}
                sortable
                unSortIcon={true}
                headerName="Role"
                cellRendererFramework={StatusBadge}
              />
            </Table>
            <Box mx={1} style={{ marginTop: "20px", display: "flex", flexDirection: "row", justifyContent: "end" }}>
              <Button onClick={selectToggle} color="secondary" variant="outlined">Cancel</Button>
            </Box>

          </Box>
        </div>
      </ThemeProvider>
    </Dialog>
  );
};
